<template>
  <button @click="test">test</button>
</template>

<script>
import * as kf from '@/utils/53kf'
export default {
  methods: {
    test() {
      kf.open()
    },
  },
}
</script>

<style></style>
